import axios from 'axios';
import * as environmentService from '../environment/environmentService';
import * as oauthService from '../oauth/oauthService';

const CertificateService = {
    getUserCertificates: (legalid) => {
        return axios.get(`${environmentService.getVidCloudMgmtUrl()}/vidmobileusers/${legalid}/certs`, oauthService.oauthHeaders());
    },

    getCertificateTypes: () => {
        return axios.get(`${environmentService.getVidCloudMgmtUrl()}/vidmobileuser/certstype`, oauthService.oauthHeaders());
    },

    updateCertificateTypes: (legalid, certificateTypes) => {
        return axios.put(`${environmentService.getVidCloudMgmtUrl()}/vidmobileusers/${legalid}/certstype`, certificateTypes, oauthService.oauthHeaders());
    },

    unauthorizeNebulaCertificate: (vidMobileUserGUID) => {
        return axios.delete(`${environmentService.getVidCloudMgmtUrl()}/vidmobileuser/${vidMobileUserGUID}/nebulaauth`, oauthService.oauthHeaders());
    }
};

export default CertificateService;

